<template>
  <transition-group
      name="snack"
      class="snackbar"
      tag="div"
  >
    <Snack
        v-for="(snack, i) in snacks"
        :key="snack.uuid"
        v-bind="snack"
        :index="i"
    />
  </transition-group>
</template>

<script setup lang="ts">
import Snack from './Snack.vue'
import { computed } from "vue"
import { useSnackbarStore } from "@/stores/useSnackbarStore"

const snackbarStore = useSnackbarStore()

const snacks = computed(() => snackbarStore.getSnacks())
</script>

<style scoped lang="scss">
@import "@/assets/css/mixins/breakpoints-up.scss";

.snackbar {
  position:    fixed;
  display:     flex;
  flex-direction: column;
  flex-flow:   column-reverse;
  align-items: flex-end;
  height:      0;
  z-index:     9999;
  bottom:      0;
  width:       100%;

  @include lg-up {
    gap:   1rem;
    bottom: 1rem;
    right: 1rem;
    width: max-content;
  }
}

.snack-move,
.snack-enter-active,
.snack-leave-active {
  transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
}

.snack-enter-from,
.snack-leave-to {
  opacity: 0;
  transform: translateX(100%);
}

.snack-leave-active {
  width: max-content;
  transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
}
</style>
